// consumerItemGroups.ts
// The consumer site sells only Fabric (005) and Wallpaper (001); Rugs, Furniture
// and Homeware live on hertexhaus.co.za. The custom-page blocks (Item Group Tiles,
// Collection Cards) must show the SAME scope as the rest of the consumer site
// (mirrors CMSConsumerItemGroupsGrid's allowlist), so their tiles are filtered to
// this allowlist.
//
// Match by item_group CODE, item_group_name, or category_name — a tile can carry
// its identity in any of these (e.g. "Homeware" is a "group" type tile with no
// item_group code, so a code-only check would let it through).

const CONSUMER_ITEM_GROUP_CODES = ['001', '005'];
const CONSUMER_ITEM_GROUP_NAMES = ['fabric', 'wallpaper'];

export const isConsumerItemGroup = (
  itemGroup?: string | null,
  itemGroupName?: string | null,
  categoryName?: string | null,
): boolean => {
  if (itemGroup && CONSUMER_ITEM_GROUP_CODES.includes(itemGroup)) return true;
  const name = (itemGroupName ?? '').toLowerCase();
  if (CONSUMER_ITEM_GROUP_NAMES.includes(name)) return true;
  const cat = (categoryName ?? '').toLowerCase();
  return CONSUMER_ITEM_GROUP_NAMES.includes(cat);
};

// A custom page is hand-picked by an editor, so one that isn't tied to any item
// group (e.g. "Performance Fabric") is allowed. The allowlist only has to filter
// tiles that carry an item group (Rugs/Furniture/Homeware).
export const isConsumerTile = (tile: {
  category_type?: string | null;
  item_group?: string | null;
  item_group_name?: string | null;
  category_name?: string | null;
}): boolean => {
  if (tile.category_type === 'custom' && !tile.item_group && !tile.item_group_name) return true;
  return isConsumerItemGroup(tile.item_group, tile.item_group_name, tile.category_name);
};
